module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/weather/snow-3-1b59693582228d38d50caee44df5beeb.svg";